import React, { useEffect, useState} from 'react';
import axios from 'axios'
import {
    Button,
    Form,
    FormGroup,
    Label,
    Input,
    Alert,
    Card,
    CardBody
} from 'reactstrap'

const ResetPasswordRequest = props => {
    const [email, setEmail] = useState('')
    const [errorMessage, setErrorMessage] = useState('')
    const [successMessage, setSuccessMessage] = useState('') 

    const onSubmit = async e => {
        e.preventDefault();
        //Clear errors
        setErrorMessage('')
        setSuccessMessage('')
        const user = {
            email
        }
        await axios.post('api/auth/resetPassword/request',user)
        .then(res => {
            setSuccessMessage(res.data.message)
            user.key = "nnnlwe19219n1b2--u0qjasca"
            user.template = "ResetPassword"
            user.title = "Link to Reset Password"
            user.descriptiontitle = "Reset Password"
            user.description = "You are recieving this because you (or someone else) has requested the reset of the password for your account. Use the reset button below within one hour of recieving it."
            user.buttonLink = `https://fobk.herokuapp.com/changepassword/${res.data.token}`
            user.buttontitle = "Reset"
            var object = JSON.stringify(user)
            axios.post('https://script.google.com/macros/s/AKfycbwaVATD7Fvhqs3xKzhr-dvgbSTXY52h_rbFxN3PRfRuC3U58VD8/exec', object)
            .catch(err => setErrorMessage(err.response.data))
        })
        .catch(err => {
            setErrorMessage(err.response.data.message)
        })
    }

    return (
        <div>
            <Card
                style = {
                {
                    width: "40%",
                    margin: "auto"
                }
                }
            >
                <CardBody
                    style = {
                        {
                            padding: "5%"
                        }
                    }
                >
                    { errorMessage? <Alert color="danger">{ errorMessage }</Alert>: null }
                    { successMessage? <Alert color="success">{ successMessage }</Alert>: null }
                    <Form onSubmit={onSubmit}>
                        <FormGroup>
                            <Label for = "email" >Email</Label>
                            <Input 
                                type = "email"
                                name = "email"
                                id = "email"
                                placeholder = "Registered Email"
                                onChange = {e => setEmail(e.target.value)}
                                required
                            />
                        </FormGroup>
                        <Button
                            color= "dark"
                            style = {{marginTop: "2rem"}}
                            block
                        >
                            Reset Password
                        </Button>
                    </Form>
                </CardBody>
            </Card> 
        </div>
    )
}


export default ResetPasswordRequest